export const cyclePhases = {
  menstrual: {
    name: 'Menstrual Phase',
    days: '1-5',
    description: 'Period begins. Estrogen and progesterone levels are low.',
    symptoms: ['Cramps', 'Fatigue', 'Headaches'],
    recommendations: ['Light exercise', 'Rest when needed', 'Iron-rich foods'],
    energy: 'Low to Moderate',
    exercise: ['Walking', 'Yoga', 'Light stretching'],
    nutrition: ['Iron-rich foods', 'Dark chocolate', 'Leafy greens']
  },
  follicular: {
    name: 'Follicular Phase',
    days: '6-14',
    description: 'Estrogen rises as follicles mature.',
    symptoms: ['Increased energy', 'Better mood', 'Mental clarity'],
    recommendations: ['High-intensity workouts', 'Start new projects', 'Social activities'],
    energy: 'High',
    exercise: ['HIIT', 'Strength training', 'Cardio'],
    nutrition: ['Protein-rich foods', 'Complex carbs', 'Fresh fruits']
  },
  ovulatory: {
    name: 'Ovulatory Phase',
    days: '15-17',
    description: 'Peak fertility. Estrogen peaks and then drops.',
    symptoms: ['Peak energy', 'Increased libido', 'Mild pain'],
    recommendations: ['Maximum effort workouts', 'Important presentations', 'Social events'],
    energy: 'Peak',
    exercise: ['High-intensity sports', 'Power lifting', 'Dance'],
    nutrition: ['Lean proteins', 'Fermented foods', 'Antioxidant-rich foods']
  },
  luteal: {
    name: 'Luteal Phase',
    days: '18-28',
    description: 'Progesterone rises. Body prepares for potential pregnancy.',
    symptoms: ['Mood changes', 'Bloating', 'Fatigue'],
    recommendations: ['Moderate exercise', 'Self-care', 'Stress management'],
    energy: 'Moderate to Low',
    exercise: ['Swimming', 'Pilates', 'Light cardio'],
    nutrition: ['Magnesium-rich foods', 'Complex carbs', 'Calming teas']
  }
};

export const remedies = [
  {
    id: 'heat-therapy',
    name: 'Heat Therapy',
    description: 'Apply heat to lower abdomen to relax muscles and improve blood flow',
    effectiveness: '85% effective',
    method: 'Use heating pad for 15-20 minutes',
    warning: 'Avoid excessive heat to prevent burns'
  },
  {
    id: 'exercise',
    name: 'Gentle Exercise',
    description: 'Light movement helps reduce cramps through endorphin release',
    effectiveness: '75% effective',
    method: 'Try yoga, walking, or light stretching for 20-30 minutes',
    warning: 'Listen to your body and avoid intense workouts'
  },
  {
    id: 'magnesium',
    name: 'Magnesium',
    description: 'Natural mineral that helps reduce muscle tension',
    effectiveness: '70% effective',
    method: 'Take 300-400mg daily with food',
    warning: 'Consult healthcare provider before supplementing'
  },
  {
    id: 'ginger-tea',
    name: 'Ginger Tea',
    description: 'Natural anti-inflammatory that helps with pain and nausea',
    effectiveness: '65% effective',
    method: 'Drink 2-3 cups daily during menstruation',
    warning: 'May interact with blood-thinning medications'
  },
  {
    id: 'massage',
    name: 'Abdominal Massage',
    description: 'Gentle massage helps improve circulation and reduce pain',
    effectiveness: '60% effective',
    method: 'Massage in circular motions for 5-10 minutes',
    warning: 'Use gentle pressure to avoid discomfort'
  },
  {
    id: 'essential-oils',
    name: 'Essential Oils',
    description: 'Lavender and clary sage oils have calming properties',
    effectiveness: '55% effective',
    method: 'Dilute with carrier oil and apply to lower abdomen',
    warning: 'Always do a patch test first'
  }
];

export const blogs = [
  {
    id: 'menstrual-hygiene',
    title: 'Essential Guide to Menstrual Hygiene',
    author: 'Dr. Sarah Chen',
    image: 'https://images.unsplash.com/photo-1591228127791-8e2eaef098d3?w=800&q=80',
    readTime: '5 min',
    content: `
      Maintaining proper menstrual hygiene is crucial for your health and comfort. Here are key practices to follow:

      1. Change products regularly
      2. Choose the right products for your flow
      3. Proper disposal methods
      4. Maintaining cleanliness
      5. Signs of potential issues to watch for
    `
  },
  {
    id: 'sustainable-products',
    title: 'Sustainable Period Products: A Complete Guide',
    author: 'Emma Thompson',
    image: 'https://images.unsplash.com/photo-1518310383802-640c2de311b2?w=800&q=80',
    readTime: '7 min',
    content: `
      Explore eco-friendly menstrual products that are better for you and the planet:

      1. Menstrual cups
      2. Reusable pads
      3. Period underwear
      4. Organic tampons
      5. Environmental impact comparison
    `
  },
  {
    id: 'exercise-benefits',
    title: 'Exercise and Your Cycle: Finding the Right Balance',
    author: 'Lisa Johnson',
    image: 'https://images.unsplash.com/photo-1583454110551-21f2fa2afe61?w=800&q=80',
    readTime: '6 min',
    content: `
      Learn how to optimize your workouts according to your cycle phases:

      1. Best exercises for each phase
      2. When to push harder
      3. When to take it easy
      4. Nutrition tips
      5. Recovery strategies
    `
  }
];